import {
  GoogleAccountSync,
  ICalendarEvent,
  IGoogleSyncUrl,
} from 'src/@types/calendar';
import { axios } from 'src/utils/axios';

export async function getEvents(): Promise<ICalendarEvent> {
  const { data } = await axios.get('/calendar/events');
  return data;
}

export async function createEvent(
  event: Omit<ICalendarEvent, '_id'>,
): Promise<ICalendarEvent> {
  const { data } = await axios.post('/calendar/events/new', event);
  return data;
}

export async function getGoogleSyncRoute(): Promise<IGoogleSyncUrl> {
  const { data } = await axios.post('/calendar/oauth/google-sync-url');
  return data;
}

export async function deleteGoogleSyncAccount(email: string) {
  const { data } = await axios.delete(`/calendar/accounts?email=${email}`);
  return data;
}

export async function getGoogleAccountsSync(): Promise<GoogleAccountSync[]> {
  const { data } = await axios.get('/calendar/accounts');
  return data;
}

export async function updateEvent(
  eventId: string,
  event: Partial<ICalendarEvent>,
): Promise<ICalendarEvent> {
  const { data } = await axios.put('/calendar/events/update', {
    eventId,
    event,
  });
  return data;
}

export async function deleteEvent(
  eventId: string,
): Promise<{ eventId: string }> {
  const { data } = await axios.delete(
    `/calendar/events/delete?eventId=${eventId}`,
  );
  return data;
}

export * as CalendarRequests from './calendar';
